import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'

import { GenerateContentElement } from '../nodes/GenerateContentElement'

export function removeGeneratedContent({
  editor,
}: {
  editor: BufferEditor
}): void {
  editor.tf.removeNodes({
    at: [],
    match: (n) => GenerateContentElement.is(n),
  })

  editor.hasGeneratedContent = false
}
